<div class="py-24 sm:py-32">
  <div
    class="max-w-3xl mx-auto px-6 py-8 font-sans text-gray-800 leading-relaxed"
    @fadeIn
  >
    <h1 class="text-4xl font-bold text-gray-900 mb-4">{{ 'privacy_policy.title' | translate }}</h1>
    <p class="text-sm text-gray-600 italic mb-8">
      {{ 'privacy_policy.last_updated' | translate:{ date: currentDate | date:'longDate' } }}
    </p>

    <div @staggerSections>
      <section class="mb-8 pb-8 border-b border-gray-200 last:border-b-0">
        <h2 class="text-2xl font-semibold text-gray-800 mb-4">{{ ('privacy_policy.content.sections' | translate)[0].number }}. {{ ('privacy_policy.content.sections' | translate)[0].title }}</h2>
        <p class="mb-4">
          {{ 'privacy_policy.content.introduction' | translate }}
        </p>
      </section>

      <section class="mb-8 pb-8 border-b border-gray-200 last:border-b-0">
        <h2 class="text-2xl font-semibold text-gray-800 mb-4">{{ ('privacy_policy.content.sections' | translate)[1].number }}. {{ ('privacy_policy.content.sections' | translate)[1].title }}</h2>
        <p class="mb-4">
          {{ 'privacy_policy.content.information_collected' | translate }}
        </p>
      </section>

      <section class="mb-8 pb-8 border-b border-gray-200 last:border-b-0">
        <h2 class="text-2xl font-semibold text-gray-800 mb-4">{{ ('privacy_policy.content.sections' | translate)[2].number }}. {{ ('privacy_policy.content.sections' | translate)[2].title }}</h2>
        <p class="mb-4">
          {{ 'privacy_policy.content.use_of_information' | translate }}
        </p>
      </section>

      <section class="mb-8 pb-8 border-b border-gray-200 last:border-b-0">
        <h2 class="text-2xl font-semibold text-gray-800 mb-4">{{ ('privacy_policy.content.sections' | translate)[3].number }}. {{ ('privacy_policy.content.sections' | translate)[3].title }}</h2>
        <p class="mb-4">
          {{ 'privacy_policy.content.sharing' | translate }}
        </p>
      </section>

      <section class="mb-8 pb-8 border-b border-gray-200 last:border-b-0">
        <h2 class="text-2xl font-semibold text-gray-800 mb-4">{{ ('privacy_policy.content.sections' | translate)[4].number }}. {{ ('privacy_policy.content.sections' | translate)[4].title }}</h2>
        <p class="mb-4">
          {{ 'privacy_policy.content.security' | translate }}
        </p>
      </section>

      <section class="mb-8 pb-8 border-b border-gray-200 last:border-b-0">
        <h2 class="text-2xl font-semibold text-gray-800 mb-4">{{ ('privacy_policy.content.sections' | translate)[5].number }}. {{ ('privacy_policy.content.sections' | translate)[5].title }}</h2>
        <p class="mb-4">
          {{ 'privacy_policy.content.your_rights.description' | translate }}
        </p>
        <ul class="list-disc pl-6 space-y-2">
          <li *ngFor="let right of ('privacy_policy.content.your_rights.rights_list' | translate); let i = index">
            {{ right }}
          </li>
        </ul>
      </section>

      <section class="mb-8 pb-8 border-b border-gray-200 last:border-b-0">
        <h2 class="text-2xl font-semibold text-gray-800 mb-4">
          {{ ('privacy_policy.content.sections' | translate)[6].number }}. {{ ('privacy_policy.content.sections' | translate)[6].title }}
        </h2>
        <p class="mb-4">
          {{ 'privacy_policy.content.childrens_privacy.description' | translate }}
        </p>
      </section>

      <section class="mb-8 pb-8 border-b border-gray-200 last:border-b-0">
        <h2 class="text-2xl font-semibold text-gray-800 mb-4">
          {{ ('privacy_policy.content.sections' | translate)[7].number }}. {{ ('privacy_policy.content.sections' | translate)[7].title }}
        </h2>
        <p class="mb-4">
          {{ 'privacy_policy.content.changes.description' | translate }}
        </p>
      </section>

      <section class="mb-8 pb-8">
        <h2 class="text-2xl font-semibold text-gray-800 mb-4">{{ ('privacy_policy.content.sections' | translate)[8].number }}. {{ ('privacy_policy.content.sections' | translate)[8].title }}</h2>
        <p class="mb-4">
          {{ 'privacy_policy.content.contact.description' | translate }}
        </p>
        <p class="text-gray-700">{{ 'privacy_policy.content.contact.contact_info' | translate }}</p>
      </section>
    </div>
  </div>
</div>
